export default [
  { value: "Rect", key: 0 },
  { value: "Image", key: 1 },
  { value: "TextMp", key: 2 },
  { value: "RawImage", key: 3 },
  { value: "Localized", key: 4 },
  { value: "Button", key: 5 },
  { value: "StoreBuyButton", key: 6 },
];
